<div class="content-align" [dir]="data.dir">
	<formio *ngIf="data.submission" [formKey]="data.formKey" [submission]="data.submission" [readOnly]="true"
		[viewOnly]="true"></formio>

	<br />
	<div class="d-flex justify-content-end">
		<button mat-flat-button (click)="cancel()" [ngClass]="{'mx-2': !data.viewOnly}">
			{{ "forms.common.cancel" | translate }}
		</button>
	</div>
</div>